export const ids = ['architect'] as const;
